import { Button } from '../Button'

import type { ComponentProps, FC } from 'react'

type Props = Omit<
  ComponentProps<typeof Button>,
  'variant' | 'size' | 'prefix' | 'suffix' | 'disabledReason' | 'wide' | 'loading'
>

export const WakuWakuButton: FC<Props> = (props) => (
  <Button {...props} variant="tertiary" size="S" className="shr-text-link-darken" />
)
